import { Box, Button, Dialog, Grid, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import * as Yup from "yup";
import moment from "moment";
import { toast } from 'react-toastify';
import CustomTextField from '../../../../Components/CustomTextField/CustomTextField';
import CustomSubmitButton from '../../../../Components/CustomSubmitButton/CustomSubmitButton';
import EditIcon from "@mui/icons-material/Edit";
import Skeleton from 'react-loading-skeleton';
import DOCUMENT_ICON from '../../../../Assets/Images/Common/documentation.png';
import UPLOAD_GALLERY_ICON from "../../../../Assets/Images/Common/gallery.png";
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { DATABASE, STORAGE } from '../../../../Config/firebase';
import { doc, setDoc, Timestamp, updateDoc, increment, writeBatch, serverTimestamp, getDoc } from 'firebase/firestore';
import { FIREBASE_CONFIG } from '../../../../Config/functions';
const NewDepositModel = (props) => {
    const { open, onClose, typeCheck, handleOnClose, customerDeposit, handleSubmited } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [mediaTypes, setMediaTypes] = useState(null);
    const [mediaUploads, setMediaUploads] = useState(null);
    const [mediaPreview, setMediaPreview] = useState(null);
    const getTimestamp = () => {
        const currentDate = moment.utc(); 
        const hour = currentDate.hour();
        if (hour >= 21) {
          currentDate.add(1, "day");
        }
        return currentDate.toDate();
      };
    const handleUploadMedia = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size <= 5 * 1024 * 1024) {
                const fileType = file.type.split('/')[0];
                const acceptedDocumentTypes = [
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                ];
                if (fileType === 'image') {
                    setMediaUploads(file);
                    setMediaTypes('image');
                    setMediaPreview(URL.createObjectURL(file));
                    formik.setFieldValue('receipt', file);
                } else if (acceptedDocumentTypes.includes(file.type)) {
                    setMediaUploads(file);
                    setMediaTypes('document');
                    setMediaPreview(null);
                    formik.setFieldValue('receipt', file);
                } else {
                    toast.error(`Invalid file type. Please upload an image or a document.`);
                }
            } else {
                toast.error(`File size exceeds the limit of 5MB`);
            }
        }
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            amount: "",
            receipt: null,
            notes: "",
            selectCustomerId: 0
        },
        validationSchema: Yup.object().shape({
            amount: Yup.string().required("Amount is required"),
            receipt: Yup.string().required("Deposit receipt is required"),
            notes: Yup.string().required("Notes are required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true);
            try {
                if (isLoading) return;
                let imageDownloadURL = null;
                if (mediaUploads) {
                    const imageRef = ref(STORAGE, `Images/profile/${Date.now()}`);
                    try {
                        await uploadBytes(imageRef, values?.receipt);
                        imageDownloadURL = await getDownloadURL(imageRef);
                    } catch (uploadError) {
                        const errorCode = uploadError?.code || "";
                        const isUnauthorized = errorCode === "storage/unauthorized";
                        if (FIREBASE_CONFIG?.isSandbox && isUnauthorized) {
                            console.warn("⚠️ Sandbox Storage unauthorized. Continuing without receipt upload for test flow.");
                            toast.warning("Sandbox Storage sem permissão. Continuando sem upload do comprovante.", {
                                autoClose: 4000,
                            });
                            imageDownloadURL = null;
                        } else {
                            throw uploadError;
                        }
                    }
                }

                const newAmount = parseFloat(values?.amount);
                const ledgersDocId = Date.now()
                const ledgersDocId1 = Date.now().toString()
                const transactionDocId = ledgersDocId1;
                
                // Create deposit with status 1 (processing) first
                const transactionData = {
                    admin_commission: 0,
                    date: Timestamp.now(),
                    request_status: 1, // Start with status 1 (processing)
                    request_type: 0,
                    notes: values.notes,
                    payment_receipt: imageDownloadURL,
                    user_id: customerDeposit[0]?.doc_id,
                    remaining_balance: 0,
                    profit_loss: 0,
                    total_amount: newAmount,
                    profit_loss_percent: 0,
                    request_approval_time: Timestamp.now(),
                    transection_fee: 0,
                    transaction_id : ledgersDocId1,
                    txn_id: ledgersDocId,
                    otp: "0",
                    otp_verify: true,
                    withdraw_amount: 0,
                    doc_id: transactionDocId,
                };
                
                // Create transaction document first (status 1)
                await setDoc(doc(DATABASE, "transection_requests", transactionDocId), transactionData);
                
                // Get current balance before batch update
                const userDoc = await getDoc(doc(DATABASE, "users", customerDeposit[0]?.doc_id));
                const currentBalance = parseFloat(userDoc?.data()?.net_balance || 0);
                const newBalance = currentBalance + newAmount;
                
                const now = Timestamp.now();
                const ledgerEntry = {
                    new_txn_amount: newAmount,
                    user_id: customerDeposit[0]?.doc_id,
                    date: now, // Use current timestamp for admin-created deposits
                    request_date: now, // Date when transaction was requested (same as created for admin)
                    conclusion_date: now, // Date when transaction was finalized (same as created for admin)
                    previous_balance: currentBalance,
                    current_balance: newBalance,
                    transection_type: 0, // Deposit
                    profit_loss_percent: 0,
                    profit_loss_balance: 0,
                    doc_id: transactionDocId,
                    request_status: 2, // Approved (admin creates with status 2)
                };

                // Use batch write for atomic operations
                const batch = writeBatch(DATABASE);
                
                // Create ledger
                const ledgerRef = doc(DATABASE, "ledgers", `deposit_${transactionDocId}`);
                batch.set(ledgerRef, ledgerEntry);
                
                // Update user balance using increment for atomic operation
                const userRef = doc(DATABASE, "users", customerDeposit[0]?.doc_id);
                batch.update(userRef, {
                    net_balance: increment(newAmount),
                    _last_balance_sync: serverTimestamp(), // Trigger app listener
                });
                
                // Immediately approve (status 2) and mark as balance updated
                const txnRef = doc(DATABASE, "transection_requests", transactionDocId);
                batch.update(txnRef, {
                    request_status: 2,
                    request_approval_time: Timestamp.now(),
                    balance_updated: true, // Idempotency flag
                });
                
                // Commit all updates atomically
                await batch.commit();
                toast.success("Deposit Added Successfully");
                resetForm();
                handleSubmited();
                handleOnClose();
                setMediaPreview(null);
                setMediaTypes(null);
                setMediaUploads(null);

            } catch (error) {
                console.error('Error:', error);
                toast.error("An error occurred. Please try again.");
            } finally {
                setIsLoading(false);
            }
        }
    });

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "20px",
                    padding: '20px 30px',
                    height: "600px",
                    overflow: "scroll",
                    "::-webkit-scrollbar": { width: "0px", height: '0px' }
                },
                "& .MuiDialogContent-root": {
                    overflowY: "initial",
                },
                "& .MuiBackdrop-root": {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                }
            }}
        >
            <form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
            }}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography sx={{ fontSize: '20px', fontWeight: '500', color: '#101010', fontFamily: "Outfit" }}>{typeCheck ? "Update" : "New"} Deposit</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end'
                        }}>
                            <IconButton sx={{
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#101010',
                                borderRadius: '8px',
                                "&:hover": {
                                    backgroundColor: '#101010',
                                    color: '#fff',
                                }
                            }} onClick={handleOnClose}>
                                <CloseIcon sx={{ color: '#fff', fontSize: '20px' }} />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{
                    padding: '20px 0px 0px 0px',
                }}>
                    <Grid spacing={2} container>
                        <Grid item xs={12}>
                            <CustomTextField
                                label="Amount"
                                type="number"
                                min="0"
                                max={1}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                onKeyDown={(evt) =>
                                    ["e", "E", "+", "-"].includes(evt.key) &&
                                    evt.preventDefault()
                                }
                                placeholder="Enter Amount"
                                name="amount"
                                value={formik?.values?.amount}
                                onBlur={formik.handleBlur}
                                onKeyUp={formik.handleBlur}
                                errors={formik?.touched?.amount && formik?.errors?.amount}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (value.trimStart() !== value) {
                                        e.target.value = value.trimStart();
                                    }
                                    formik.handleChange(e);
                                }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        borderRadius: "10px",
                                        border: "1px solid #CACACA",
                                        color: "black",
                                        fontSize: "18px",
                                        background: "white",
                                        fontFamily: "Outfit",
                                    },
                                }}
                                style={{ color: "black", fontSize: "18px" }}
                                isLoading={isLoading}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTextField
                                label="Notes"
                                type="text"
                                placeholder="Enter your notes"
                                name="notes"
                                value={formik?.values?.notes}
                                onBlur={formik.handleBlur}
                                onKeyUp={formik.handleBlur}
                                multiline={true}
                                rows={3}
                                errors={formik?.touched?.notes && formik?.errors?.notes}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (value.trimStart() !== value) {
                                        e.target.value = value.trimStart();
                                    }
                                    formik.handleChange(e);
                                }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        borderRadius: "10px",
                                        border: "1px solid #CACACA",
                                        color: "black",
                                        fontSize: "18px",
                                        background: "white",
                                        fontFamily: "Outfit",
                                    },
                                }}
                                style={{ color: "black", fontSize: "18px" }}
                                isLoading={isLoading}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    width: { xs: "100%", md: "100%", lg: "400px" },
                                    display: "flex",
                                    gap: "20px",
                                    flexDirection: { xs: "column" },
                                    margin: '0 auto',
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "black",
                                        fontWeight: "400",
                                        textAlign: "left",
                                        fontSize: { xs: "14px", sm: "16px" },
                                    }}
                                >
                                    Deposit Receipt
                                </Typography>
                                {isLoading ? (
                                    <Skeleton height={200} />
                                ) : (
                                    <>
                                        <Box
                                            sx={{
                                                width: "100%",
                                                margin: '0 auto',
                                                height: "200px",
                                                overflow: "hidden",
                                                background: "#fff",
                                                position: "relative",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "10px",
                                                border: "1px solid #CACACA",
                                            }}
                                        >
                                            {!mediaTypes ? (
                                                <label htmlFor="document">
                                                    <Button
                                                        component="span"
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            flexDirection: "column",
                                                            outline: "none",
                                                            border: "none",
                                                            backgroundColor: "transparent",
                                                            textTransform: "capitalize",
                                                        }}
                                                        type="button"
                                                    >
                                                        <img src={UPLOAD_GALLERY_ICON} alt="Upload Icon" width={"42px"} />
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontSize: "14px",
                                                                fontWeight: "600",
                                                                color: "#000000",
                                                                margin: "8px 0px !important",
                                                            }}
                                                        >
                                                            Deposit Receipt
                                                        </Typography>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontSize: "14px",
                                                                fontWeight: "600",
                                                                color: "#9C9C9C",
                                                            }}
                                                        >
                                                            {`(PSD, DOC, PDF, JPG, PNG)`}
                                                        </Typography>
                                                        <input
                                                            accept="image/*,.pdf,.doc,.docx,.psd"
                                                            style={{ display: "none" }}
                                                            id="document"
                                                            type="file"
                                                            onChange={handleUploadMedia}
                                                        />
                                                    </Button>
                                                </label>
                                            ) : (
                                                <Box sx={{ textAlign: "center" }}>
                                                    {mediaTypes === 'image' ? (
                                                        <img src={mediaPreview} alt="Uploaded" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                    ) : (
                                                        <>
                                                            <img src={DOCUMENT_ICON} alt="document" style={{ width: "100px" }} />
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    fontSize: "14px",
                                                                    fontWeight: "600",
                                                                    color: "#9C9C9C",
                                                                    padding: "5px 0px",
                                                                }}
                                                            >
                                                                Document Uploaded
                                                            </Typography>
                                                        </>
                                                    )}
                                                    <label htmlFor="document">
                                                        <IconButton
                                                            component="span"
                                                            sx={{
                                                                width: "40px",
                                                                height: "40px",
                                                                borderRadius: "16px",
                                                                backgroundColor: "#ffffff",
                                                                boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                                                                transition: "0.5s",
                                                                position: "absolute",
                                                                right: "5px",
                                                                top: "5px",
                                                                "&:hover": {
                                                                    backgroundColor: "#ffffff",
                                                                }
                                                            }}
                                                        >
                                                            <EditIcon sx={{ color: "#000", fontSize: "26px" }} />
                                                        </IconButton>
                                                        <input
                                                            accept="image/*,.pdf,.doc,.docx,.psd"
                                                            style={{ display: "none" }}
                                                            id="document"
                                                            type="file"
                                                            onChange={handleUploadMedia}
                                                        />
                                                        <IconButton
                                                            component="span"
                                                            sx={{
                                                                width: "40px",
                                                                height: "40px",
                                                                borderRadius: "16px",
                                                                backgroundColor: "#ffffff",
                                                                boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                                                                transition: "0.5s",
                                                                position: "absolute",
                                                                right: "50px",
                                                                top: "5px",
                                                                "&:hover": {
                                                                    backgroundColor: "#ffffff",
                                                                }
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setMediaUploads(null);
                                                                setMediaPreview(null);
                                                                setMediaTypes(null);
                                                            }}
                                                        >
                                                            <CloseIcon sx={{ color: "#000", fontSize: "26px" }} />
                                                        </IconButton>
                                                    </label>
                                                </Box>
                                            )}
                                        </Box>
                                        {formik?.touched?.receipt && formik?.errors?.receipt ? (
                                            <Typography
                                                sx={{
                                                    color: "red",
                                                    fontWeight: "400",
                                                    fontSize: { xs: "14px", sm: "14px" },
                                                }}
                                            >
                                                {formik?.errors?.receipt}
                                            </Typography>
                                        ) : null}
                                    </>
                                )}
                            </Box>

                        </Grid>
                        <Grid item xs={12}>
                            <CustomSubmitButton
                                btnTitle={typeCheck ? "Update Proof" : "Send Proof"}
                                loading={isLoading}
                                type="submit"
                            />
                        </Grid>
                    </Grid>
                </Box>
            </form>
        </Dialog>
    );
};

export default NewDepositModel;